<template>
    <ul class="d-flex">
        <li
            v-for="(spot, i) in spots"
            :key="`spot-${i}`"
            :class="{ 'busy': spot, 'busy-spot': spot && !spot.uid }">
                <a-tooltip v-if="spot && spot.uid">
                    <template slot="title">
                        {{ spot.cname }}
                    </template>
                    <img
                        v-lazy="spot.cimage"
                        alt="campaign cover">
                </a-tooltip>
                <div v-else v-b-tooltip.hover="!spot? 'Free spot': 'Busy spot'">
                    <span>{{i + 1}}</span>
                </div>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'UpdateSpots',
    props: {
        spots: Array,
    },
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/variables.scss';
ul {
    margin: 0;
    padding: 0;
    li {
        width: 30px;
        height: 30px;
        border-radius: 50%; 
        background: $c14;
        border: 1px solid $c4;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 12px;

        &.busy {
            border: 0 !important;
        }
        &.busy-spot {
            background: $c2;
            color: $c14;
        }
        img {
            width: 100%;
            height: 100%;
            border-radius: 50%;
            object-fit: cover;
        }
        span {
            font-size: $p4;
        }
    }
}
</style>